import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { setDayjsLocale, default as dayjs } from '../config/dayjs';
import { toDayjsLocale } from '../constants/locales';

type Props = { children: ReactNode };

export const I18nLocaleProvider = ({ children }: Props) => {
  const { i18n } = useTranslation();
  const [adapterLocale, setAdapterLocale] = useState<string>(
    toDayjsLocale(i18n.language),
  );

  useEffect(() => {
    const handleChange = (lng: string) => {
      setDayjsLocale(lng);
      setAdapterLocale(toDayjsLocale(lng));
    };
    setDayjsLocale(i18n.language);
    setAdapterLocale(toDayjsLocale(i18n.language));
    i18n.on('languageChanged', handleChange);
    return () => {
      i18n.off('languageChanged', handleChange);
    };
  }, [i18n]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale} dateLibInstance={dayjs}>
      {children}
    </LocalizationProvider>
  );
};
